<template>
  <div v-show="wizard.show" class="bg-white my-3" style="border-radius: 20px; box-shadow: 0 0 5px #8ce3d6;">
    <div v-if="wizard.current_step > 0" class="d-flex align-items-center justify-content-around mb-3 p-4">
      <div @click="goto_step(1)" :style="wizard.current_step > 1 ? 'cursor: pointer !important;' : ''">
        <div>
          <img src="@/pages/dashboard/userwizard/assets/clipboard.svg" width="64" height="64" class="filter_green">
        </div>
        <div class="text-center mt-2">
          <span v-if="current_user.user_type == user_types.LEGAL" style="color: #00bea5">مشخصات شرکت</span>
          <span v-else style="color: #00bea5">مشخصات فردی</span>
        </div>
      </div>
      <div>
        <img src="@/pages/dashboard/userwizard/assets/left-arrow.svg" width="16" height="16" :class="wizard.current_step > 1 ? 'filter_green' : 'filter_gray'">
      </div>
      <div @click="goto_step(2)" :style="wizard.current_step > 2 ? 'cursor: pointer !important;' : ''">
        <div>
          <img src="@/pages/dashboard/userwizard/assets/bank.svg" width="64" height="64" :class="wizard.current_step > 1 ? 'filter_green' : 'filter_gray'">
        </div>
        <div class="text-center mt-2">
          <span :style="wizard.current_step > 1 ? 'color: #00bea5' :'color: #d2d2d2'">حساب بانکی</span>
        </div>
      </div>
      <div>
        <img src="@/pages/dashboard/userwizard/assets/left-arrow.svg" width="16" height="16" :class="wizard.current_step > 2 ? 'filter_green' : 'filter_gray'">
      </div>
      <div @click="goto_step(3)" :style="wizard.current_step > 3 ? 'cursor: pointer !important;' : ''">
        <div>
          <img src="@/pages/dashboard/userwizard/assets/bus-stop.svg" width="64" height="64" :class="wizard.current_step > 2 ? 'filter_green' : 'filter_gray'">
        </div>
        <div class="text-center mt-2">
          <span :style="wizard.current_step > 2 ? 'color: #00bea5' :'color: #d2d2d2'">آدرس</span>
        </div>
      </div>
      <div>
        <img src="@/pages/dashboard/userwizard/assets/left-arrow.svg" width="16" height="16" :class="wizard.current_step > 3 ? 'filter_green' : 'filter_gray'">
      </div>
      <div @click="goto_step(4)">
        <div>
          <img src="@/pages/dashboard/userwizard/assets/authentication.svg" width="64" height="64" :class="wizard.current_step > 3 ? 'filter_green' : 'filter_gray'">
        </div>
        <div class="text-center mt-2">
          <span  :style="wizard.current_step > 3 ? 'color: #00bea5' :'color: #d2d2d2'">مدارک هویتی</span>
        </div>
      </div>
    </div>

    <hr class="custom_hr" v-if="wizard.current_step > 0">

    <div class="p-5">
      <div v-if="wizard.current_step === 0">
        <wizard-entry-point :wizard="wizard"></wizard-entry-point>
      </div>
      <div v-if="wizard.current_step === 1">
        <account-form :wizard="wizard"></account-form>
      </div>
      <div v-if="wizard.current_step === 2">
        <sheba-form :wizard="wizard"></sheba-form>
      </div>
      <div v-if="wizard.current_step === 3">
        <address-form :wizard="wizard"></address-form>
      </div>
      <div v-if="wizard.current_step === 4">
        <auth-form :wizard="wizard"></auth-form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import AccountForm from "./userwizard/account";
import ShebaForm from "./userwizard/sheba";
import AddressForm from "./userwizard/address";
import AuthForm from "./userwizard/auth";
import WizardEntryPoint from "./userwizard/entry-point";
import { userStatusStr, userStatus } from "@/constants/userStatus";
import { userTypes } from '@/constants/userTypes';

export default {
  components: {
    AccountForm,
    ShebaForm,
    AddressForm,
    AuthForm,
    WizardEntryPoint,
  },
   mounted() {
      if (this.is_authenticated_pending) {
        this.wizard.navigable = false;
        this.wizard.current_step = 4;
      }
      else if(this.current_user.status == userStatus.ACTIVE){
        this.wizard.navigable = true;
        this.wizard.current_step = 0;
      }
      else {
        if(document.referrer === 'https://paystar.shop/'){
            this.wizard.navigable = true;
            this.wizard.current_step = 1;
        }else{
          this.wizard.navigable = true;
          this.wizard.current_step = 0;
        }
      }
      this.wizard.show = true;
  },
  data() {
    return {
      user_types: userTypes,
      userStatus: userStatus,
      wizard: {
        current_step: 0,
        show: false,
        navigable: true,
      },
    };
  },
  computed: {
    ...mapGetters("user", [
      "is_authenticated_pending",
      "current_user"
    ]),
  },
  methods: {
    goto_step(selected_step) {
      if (this.wizard.navigable && (this.wizard.current_step > selected_step)) {
        this.wizard.current_step = selected_step;
      }
    },
  },
};
</script>

<style scoped>
.filter_green {
  filter: invert(68%) sepia(25%) saturate(7218%) hue-rotate(130deg) brightness(91%) contrast(101%);
}

.filter_gray {
  filter: invert(87%) sepia(1%) saturate(200%) hue-rotate(314deg) brightness(101%) contrast(86%);
}
</style>
